import axios from "axios";
import { signOutSuccess } from "store/slices/authSlice";
import store from "../store";

const API_URL = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true, // Enable withCredentials globally
});

let isLoggingOut = false;

axiosInstance.interceptors.response.use(
  (response) => {
    const { success, message } = response?.data || {};

    if (
      success === false &&
      message === "You are not logged in" &&
      !isLoggingOut
    ) {
      isLoggingOut = true;
      store.dispatch(signOutSuccess()).finally(() => {
        window.location.href = "/auth/login";
      });
      return Promise.reject(new Error("You are not logged in"));
    }

    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
